'use strict';

var deprecate = require('util-deprecate');
var classNames = require('classnames');

module.exports = deprecate(classNames, '`rcUtil.classSet()` is deprecated, use `classNames()` by `require(\'classnames\')` instead');


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-util/lib/classSet.js
 ** module id = 428
 ** module chunks = 0
 **/